/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiGetSettingDefinitionRequestFromJSON(json) {
    return StreemApiGetSettingDefinitionRequestFromJSONTyped(json, false);
}
export function StreemApiGetSettingDefinitionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'settingName': !exists(json, 'setting_name') ? undefined : json['setting_name'],
    };
}
export function StreemApiGetSettingDefinitionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'setting_name': value.settingName,
    };
}
//# sourceMappingURL=StreemApiGetSettingDefinitionRequest.js.map